import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { getMenusV2 } from 'redux/actions/Menu/menuV2';
import { selectCurrentBusiness } from 'redux/selectors';
import { BUSINESS_TYPE_CATEGORY } from 'constants/companyTypes';
import UpdateProviderMenuButton from './UpdateProviderMenuButton';

const InventoryHeader = ({ handleDrawerOpen, open }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const currentBusiness = useSelector(selectCurrentBusiness);

  // Businesses whose type includes the nested-menu category don't use the
  // legacy provider-menu sync flow, so the "Update/Connect Provider Menus"
  // button (and its confirm modal / messaging) is hidden for them.
  const isRestaurantWithNestedMenu = currentBusiness?.businessTypes?.includes(
    BUSINESS_TYPE_CATEGORY.restaurantWithNestedMenu
  );

  // Check if we're on the item form page
  const isItemForm = location.pathname.includes('/inventory/items/');
  const isCategoryForm = location.pathname.includes('/inventory/categories/');
  const searchParams = new URLSearchParams(location.search);
  const itemName = searchParams.get('name') || '';
  const categoryName = searchParams.get('name') || '';

  // Fetch menu data when navigating to inventory (similar to menu page).
  // Skipped for nested-menu businesses, which don't use the legacy provider
  // menu sync flow that this data feeds.
  useEffect(() => {
    if (isRestaurantWithNestedMenu) return;
    dispatch(getMenusV2(false));
  }, [location.pathname, dispatch, isRestaurantWithNestedMenu]);

  return (
    <>
      <Box sx={{ pt: '8px' }}>
        <Box
          sx={{
            flexWrap: 'wrap',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              id="inventoryHeaderMenu"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{ mr: 2, ...(open && { display: 'none' }) }}
            >
              <MenuIcon />
            </IconButton>

            {isItemForm && itemName ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography sx={{ color: '#3D4350', fontSize: '20px' }}>
                  {t('Inventory Items')} {'>'} {itemName}
                </Typography>
              </Box>
            ) : isCategoryForm && categoryName ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography sx={{ color: '#3D4350', fontSize: '20px' }}>
                  {t('Inventory Categories')} {'>'} {categoryName}
                </Typography>
              </Box>
            ) : (
              <Typography sx={{ color: '#3D4350', fontSize: '20px' }}>
                {t('Inventory')}
              </Typography>
            )}
            {!isRestaurantWithNestedMenu && (
              <UpdateProviderMenuButton buttonId="InventorySync" />
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default InventoryHeader;
